export default __webpack_public_path__ + "static/media/36I-102632_-15551_0.e81e6380.jpg";